import React from 'react'
import { Grid } from '@mui/material'
import { ROUTES } from '../../router'
import LinkCard, { LinkCardProps } from './components/LinkCard'
import { AdminPanelSecObjects, SecurityComponents } from 'src/types/security'
import { SafetyComponent } from 'src/components/security'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import GroupsIcon from '@mui/icons-material/Groups'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import BadgeIcon from '@mui/icons-material/Badge'
import ApartmentIcon from '@mui/icons-material/Apartment'
import HistoryIcon from '@mui/icons-material/History'

const cardLinkProps: LinkCardProps[] = [
    {
        to: ROUTES.USUARIOS,
        title: 'Usuarios',
        icon: ManageAccountsIcon,
        color: '#4f46e5',
        securityObject: AdminPanelSecObjects.LinkTablaUsuarios
    },
    {
        to: ROUTES.GRUPOS,
        title: 'Grupos',
        icon: GroupsIcon,
        color: '#0891b2',
        securityObject: AdminPanelSecObjects.LinkTablaGrupos
    },
    {
        to: ROUTES.ETAPAS,
        title: 'Etapas',
        icon: AccountTreeIcon,
        color: '#059669',
        securityObject: AdminPanelSecObjects.LinkTablaEtapas
    },
    {
        to: ROUTES.PERFILES,
        title: 'Perfiles',
        icon: BadgeIcon,
        color: '#d97706',
        securityObject: AdminPanelSecObjects.LinkTablaPerfiles
    },
    {
        to: ROUTES.SECTORES_COMERCIALES,
        title: 'Sectores Comerciales',
        icon: ApartmentIcon,
        color: '#dc2626',
        securityObject: AdminPanelSecObjects.LinkTablaSectoresComerciales
    },
    {
        to: ROUTES.EVENTOS,
        title: 'Eventos',
        icon: HistoryIcon,
        color: '#7c3aed',
        securityObject: AdminPanelSecObjects.LinkTablaSectoresComerciales
    }
]

function Admin() {
    return (
        <Grid container spacing={3}>
            {cardLinkProps.map((cardProps, index) => (
                <SafetyComponent componentName={SecurityComponents.AdminPanel} objectName={cardProps.securityObject}>
                    <Grid key={index} item xs={6} sm={4} md={3}>
                        <LinkCard {...cardProps} />
                    </Grid>
                </SafetyComponent>
            ))}
        </Grid>
    )
}

export default Admin
